// En jackpotStore.js - mantenemos simple y corregimos sintaxis
import { defineStore } from 'pinia';
import { api, publicApi } from '../../services/api';

export const useJackpotStore = defineStore('jackpot', {
  state: () => ({
    jackpots: [],
    isLoading: false,
    adminId: null // Guardamos el adminId actual
  }),

  getters: {
    jackpotsByLevel: (state) => {
      return {
        iron: state.jackpots.find(j => j?.level === 1),
        bronze: state.jackpots.find(j => j?.level === 2),
        silver: state.jackpots.find(j => j?.level === 3),
        gold: state.jackpots.find(j => j?.level === 4),
        platinum: state.jackpots.find(j => j?.level === 5),
        diamond: state.jackpots.find(j => j?.level === 6)
      };
    },
    displayUrls: (state) => {
      return state.jackpots.reduce((acc, j) => {
        acc[j.level] = j.display_url;
        return acc;
      }, {});
    }
  },

  actions: {
    // Modificamos initialize para usar loadExternalJackpots si hay adminId
    async initialize() {
      try {
        console.log('🎰 Initializing jackpots...');
        this.isLoading = true;
        
        // Si hay adminId guardado, usamos ese
        if (this.adminId) {
          console.log('🎰 Using saved adminId:', this.adminId);
          await this.loadExternalJackpots(this.adminId);
          return;
        }
        
        // Si no hay adminId, procedemos como antes
        const response = await api.get('/jackpots');
        if (response.data.jackpots) {
          // Si hay jackpots y tienen admin_id, lo guardamos
          if (response.data.jackpots.length > 0 && response.data.jackpots[0].admin_id) {
            this.adminId = response.data.jackpots[0].admin_id;
            console.log('🎰 Found adminId in response:', this.adminId);
          }
          
          this.jackpots = response.data.jackpots;
        }
      } catch (error) {
        console.error('Error loading jackpots:', error);
      } finally {
        this.isLoading = false;
      }
    },

    // Mantener loadExternalJackpots sin cambios
    async loadExternalJackpots(admin_id) {
      try {
        console.log('🎯 Loading external jackpots for:', admin_id);
        this.adminId = admin_id; // Guardar adminId
        
        const response = await publicApi.get(`/jackpots/external/${admin_id}`);
        console.log('🎯 External jackpots response:', response.data);
        
        if (response.data.jackpots) {
          this.jackpots = response.data.jackpots;
        }
      } catch (error) {
        console.error('Error loading external jackpots:', error);
      }
    },

    // Actualización desde socket
    updateJackpotsFromSocket(jackpots) {
      console.log('🎰 Updating jackpots from socket');
      this.jackpots = jackpots;
      
      // Si hay jackpots y tienen admin_id, lo guardamos
      if (jackpots.length > 0 && jackpots[0].admin_id) {
        this.adminId = jackpots[0].admin_id;
      }
    }
  }
});